import React, { memo, type ReactElement } from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
import {
	Droppable,
	type DroppableProvided,
	type DraggableChildrenFn,
	type DroppableStateSnapshot,
} from 'react-beautiful-dnd';
import { COLUMN_DND_TYPE } from '@atlassian/jira-platform-board-kit';

type Props = {
	dropZoneMode?: 'standard' | 'virtual';
	renderClone?: DraggableChildrenFn;
	isDropDisabled?: boolean;
	children: (arg1: DroppableProvided, arg2: DroppableStateSnapshot) => ReactElement;
};

export const ColumnsDroppable = memo<Props>((props: Props) => {
	const { children, dropZoneMode, renderClone, isDropDisabled } = props;

	return (
		<Droppable
			droppableId="board"
			type={COLUMN_DND_TYPE}
			direction="horizontal"
			ignoreContainerClipping
			mode={dropZoneMode}
			renderClone={renderClone}
			isDropDisabled={isDropDisabled}
		>
			{(provided, snapshot) => children(provided, snapshot)}
		</Droppable>
	);
});
